var COGS_GENERATED_SKELETON_ROW_KEY = 'cogsAutomaticGeneratedSkeletonRow';

export { COGS_GENERATED_SKELETON_ROW_KEY };
